document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.statistics-card__title');

  const formatNumber = (n, hasComma, hasDots) => {
    if (hasComma && !hasDots) {
      return n.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
    } else if (hasDots) {
      return Math.floor(n).toLocaleString('de-DE');
    } else {
      return n.toLocaleString('de-DE');
    }
  };

  const countUp = (counter) => {
    const text = counter.innerText;
    const hasComma = text.includes(',');
    const hasDots = text.includes('.');
    const target = parseFloat(text.replace(/[^0-9,]/g, '').replace(',', '.'));
    const suffix = text.replace(/[0-9.,]/g, '');

    if (isNaN(target)) return;

    const duration = 1300;
    const frameRate = 20;
    const frames = duration / frameRate;

    const isDecimal = hasComma && !hasDots && target < 2;
    const step = target / frames; // dynamic step so all end together
    let current = 0;

    const tick = setInterval(() => {
      current = Math.min(target, current + step);
      const display = isDecimal ? +current.toFixed(2) : Math.round(current);
      counter.innerText = formatNumber(display, hasComma, hasDots) + suffix;

      if (current >= target) clearInterval(tick);
    }, frameRate);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        countUp(e.target);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  counters.forEach((c) => observer.observe(c));
});
